import { LegacyImage, Video } from '$shared/components';
import React from 'react';
import { useMedia } from 'react-use';
import { M70MediaModule } from '~/lib/data-contract';
import { queries } from '~/theme';
import { useThemeShade } from '~/theme';
import { StyledGrid, StyledM70, StyledCaption } from './styled';
import { Container } from '../container/container.component';

export type M70MediaProps = M70MediaModule;

export const M70Media = ({ image, video, caption, ...rest }: M70MediaProps) => {
    const { textShade } = useThemeShade({});
    const mediaType = video ? 'video' : 'image';
    const isImage = mediaType === 'image';
    const isMobile = !useMedia(queries.md, false);

    return (
        <Container hasGutter="medium" {...rest} spacingTop='default' spacingBottom='default'>
            <StyledM70 textShade={textShade} as={isImage ? 'figure' : 'div'}>
                <StyledGrid mediaType={mediaType}>
                    {mediaType === 'image' && image?.src ? (
                        <LegacyImage
                            {...image}
                            src={image.src}
                            alt={image.alt}
                            cW={isMobile ? 5 : 12}
                            cH={isMobile ? 4 : 5}
                            layout="fill"
                            objectFit="cover"
                        />
                    ) : null}
                    {mediaType === 'video' && video?.src ? (
                        <Video
                            controls={false}
                            src={video.src}
                            loop={video.loop}
                            playing={video.autoPlay}
                            cover
                            posterSrc={image?.src}
                            showCustomButtons={video.controls}
                        />
                    ) : null}
                    {caption ? <StyledCaption variant="caption" children={caption} /> : null}
                </StyledGrid>
            </StyledM70>
        </Container>
    );
};
